<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
      <path fill="inherit" stroke="none" d="m12 15-5-5h10z" />
    </svg>
  </span>
</template>
